// faq-page.js

document.addEventListener('DOMContentLoaded', function () {

  // ---- FAQ Accordion ----
  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(function (item) {
    const btn = item.querySelector('.faq-item__question');
    const icon = item.querySelector('.faq-item__icon');

    btn.addEventListener('click', function () {
      const isOpen = item.classList.contains('faq-item--open');

      // Sabhi band karo
      faqItems.forEach(function (el) {
        el.classList.remove('faq-item--open');
        el.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
        el.querySelector('.faq-item__icon').textContent = '+';
      });

      // Agar pehle band tha toh kholo
      if (!isOpen) {
        item.classList.add('faq-item--open');
        btn.setAttribute('aria-expanded', 'true');
        icon.textContent = '−';
      }
    });
  });

  // ---- Scroll to Top ----
  const scrollBtn = document.querySelector('.faq-scroll-top');
  if (scrollBtn) {
    window.addEventListener('scroll', function () {
      scrollBtn.style.display = window.scrollY > 300 ? 'flex' : 'none';
    });
    scrollBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

});
